import {NotifyManager} from "notify-component";

/** @TODO перенести в /api */

/**
 * Интерфейс входящих параметров запроса
 */
interface makeRequestParams {
    url: string;
    method?: string;
    data?: any;
    callback?: any;
    errorCallback?: any;
    userId: number;
}

const setRequestSchema = (): string => {
    if (process.env.REACT_APP_ENV === 'local') {
        return 'http';
    } else return process.env.REACT_APP_SOCKET_TLS === 'wss' ? 'https' : 'http';
}
export const makeRequest = (params: makeRequestParams) => {
    const {url, method, data, callback, userId, errorCallback} = params;

    /**
     * @var {string} schema Если фронт запускается локально, пробросим http.
     * @TODO написать конфиг лучше того, что есть сейчас, с учетом возможности проксирования удаленных чатов
     */
    let schema = setRequestSchema();

    /**
     * @var {string} chatApplicationUrl если фронт запускается локально, укажем, что надлежит явно проставить порт, т.к. запросы к чату могут идти на http
     */
    const chatApplicationUrl: string | undefined = (process.env.REACT_APP_CHAT_APP_PORT && process.env.REACT_APP_ENV === 'local')
        ? process.env.REACT_APP_SOCKET_HOST + ':' + process.env.REACT_APP_CHAT_APP_PORT
        : process.env.REACT_APP_SOCKET_HOST;

    const fullUrl: string = schema + '://' + chatApplicationUrl + '/trigger/' + url;
    console.debug('[makeRequest] Full URL:', fullUrl);

    let api_token = localStorage.getItem('api_token');

    const requestOptions = {
        method: method ?? 'POST',
        headers: {
            'Authorization': api_token,
            'UserId': process.env.REACT_APP_ENV + '-' + userId,
            'Content-Type': 'application/json',
        },
        keepalive: true,
        body: JSON.stringify(data)
    };

    console.debug('[makeRequest] Request options:', requestOptions);

    try {
        console.log(data);
        // @ts-ignore
        fetch(fullUrl, requestOptions)
            .then(response => {
                let status = response.status;
                if (status === 403) // не показывать эту ошибку, так как запрос идёт в фоне
                {
                    return {};
                }

                return response.json();
            })
            .then(data => {
                // @ts-ignore
                if (data?.result === 'success') {
                    if (typeof callback === 'function') {
                        // @ts-ignore
                        callback(data?.data)
                    }
                } else {
                    // @ts-ignore
                    if (data?.meta?.text) {
                        // @ts-ignore
                        NotifyManager.error('', data?.meta?.text);
                    }

                    if (typeof errorCallback === 'function') {
                        errorCallback();
                    }
                }
            }).catch(error => {
            console.error({title: '[makeRequest] Fetch error:', error: error});
            if (typeof errorCallback === 'function') {
                errorCallback();
            }
        });
    } catch (e) {
        if (typeof errorCallback === 'function') {
            errorCallback();
        }
    }
}